import React from 'react';

import Typography from '@material-ui/core/Typography';

const Title = props => {
  return <Typography variant="h5" gutterBottom>
    <b>{ props.children }</b>
  </Typography>
}

export default Title;
